import { Card, CardActionArea, CardContent, Tooltip } from "@mui/material";
import React, { FC } from "react";

import TooltipContent from "./components";

import { Grid, Typography } from "@components/base";

interface CardGuideStep {
  title: string;
  description: string;
  detail?: {
    title: string;
    points: string[];
  };
  button?: {
    text: string;
    onClick?(): void;
    href?: string;
  };
  onClickStep?: () => void;
  clicked?: boolean;
  active?: boolean;
  disabled?: boolean;
  tooltip?: {
    title: string;
    points: string[];
  };
}

const CardGuideStep: FC<CardGuideStep> = ({
  title,
  tooltip,
  description,
  onClickStep,
  clicked,
  active,
  disabled,
}) => (
  <Tooltip
    title={
      tooltip ? <TooltipContent title={tooltip.title} points={tooltip.points} /> : ""
    }
    placement="bottom"
    arrow
    disableHoverListener={!tooltip}
  >
    <Card
      sx={{ height: "100%" }}
      variant="outlined"
      className={`step ${clicked && "clicked"} ${active && "active"} ${disabled && "disabled"}`}
    >
      <CardActionArea onClick={onClickStep} disabled={disabled} sx={{ height: "inherit" }}>
        <CardContent>
          <Grid container>
            <Grid size={12}>
              <Grid container justifyContent="space-between">
                <Grid>
                  <Typography variant="body1">{title}</Typography>
                </Grid>
                <Grid>
                  {!clicked && (
                    <img
                      alt="bulb"
                      src="/static/icons/bulb.svg"
                      height={16}
                      width={16}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <Typography variant="body2">{description}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  </Tooltip>
);

export default CardGuideStep;
